import { defineComponent, useModel, ref, watch, onMounted, openBlock, createElementBlock, createBlock, createCommentVNode, mergeModels } from 'vue';
import '@ssml-editor/core';
import '@ssml-editor/vue';
import '../../module/phoneme/alphabet.enum.js';
import '../../module/say-as/say-as-interpretation.enum.js';
import '@ssml-editor/modules';
import { Effect } from '../../module/speak/effect.enum.js';
import '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/create-editor-z7CFqjGE.js';
import 'element-plus';
/* empty css                                                                                                                                           */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                   */
/* empty css                                                     */
/* empty css                                                                                                                                                */
/* empty css                                                                                                                                                 */
/* empty css                                     */
/* empty css                                                                                                                                              */
/* empty css                                                                                                                                               */
import '@ssml-editor/base';
/* empty css                                                                                                                                                 */
/* empty css                                                                                                                                                      */
/* empty css                                                                                                                                                */
/* empty css                      */
import 'cmu-pronouncing-dictionary';
/* empty css                          */
import '../../../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/hotkeys-BEBL6MB3.js';
/* empty css                        */
import '../say-as/constant.js';
/* empty css                        */
import '@element-plus/icons-vue';
/* empty css                                     */
import '../../../_virtual/lodash.js';
/* empty css                                                                                                                                             */
/* empty css                */
/* empty css                  */
import EffectEq from './effect-eq.js';
import _sfc_main$1 from './effect-filter.vue.js';
/* empty css                           */
/* empty css                      */
/* empty css                  */
import '../voice/voice-menu.vue.js';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "effect-value-container",
  props: /* @__PURE__ */ mergeModels({
    effect: {}
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props) {
    const model = useModel(__props, "modelValue");
    const eqValue = ref("0 0 0 0 0 0 0 0");
    const lpFilterValue = ref("6000");
    const hpFilterValue = ref("12000");
    function updateHandler() {
      if (__props.effect === Effect.EQ) {
        model.value = eqValue.value;
      } else if (__props.effect === Effect.LPFILTER) {
        model.value = lpFilterValue.value;
      } else if (__props.effect === Effect.HPFILTER) {
        model.value = hpFilterValue.value;
      }
    }
    watch(() => __props.effect, (newValue) => {
      if (newValue === Effect.EQ) {
        model.value = eqValue.value;
      } else if (newValue === Effect.LPFILTER) {
        model.value = lpFilterValue.value;
      } else if (newValue === Effect.HPFILTER) {
        model.value = hpFilterValue.value;
      } else {
        model.value = void 0;
      }
    });
    onMounted(async () => {
      if (model.value) {
        if (__props.effect === "eq") {
          eqValue.value = model.value;
        } else if (__props.effect === "lpfilter") {
          lpFilterValue.value = model.value;
        } else if (__props.effect === "hpfilter") {
          hpFilterValue.value = model.value;
        }
      }
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", { class: "se-effect-value-container" }, [
        __props.effect === "eq" ? (openBlock(), createBlock(EffectEq, {
          key: 0,
          modelValue: eqValue.value,
          "onUpdate:modelValue": [($event) => eqValue.value = $event, ($event) => updateHandler()]
        }, null, 8, ["modelValue", "onUpdate:modelValue"])) : createCommentVNode("", true),
        __props.effect === "lpfilter" ? (openBlock(), createBlock(_sfc_main$1, {
          key: 1,
          modelValue: lpFilterValue.value,
          "onUpdate:modelValue": [($event) => lpFilterValue.value = $event, ($event) => updateHandler()]
        }, null, 8, ["modelValue", "onUpdate:modelValue"])) : createCommentVNode("", true),
        __props.effect === "hpfilter" ? (openBlock(), createBlock(_sfc_main$1, {
          key: 2,
          modelValue: hpFilterValue.value,
          "onUpdate:modelValue": [($event) => hpFilterValue.value = $event, ($event) => updateHandler()]
        }, null, 8, ["modelValue", "onUpdate:modelValue"])) : createCommentVNode("", true)
      ]);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=effect-value-container.vue2.js.map
